"use client";

import { Plus } from "lucide-react";
import { DragHandle } from "./DragHandle";
import { IconButton } from "./IconButton";

interface BlockActionBarProps {
  visible?: boolean;
  onAddClick?: () => void;
  onDragStart?: () => void;
  className?: string;
}

export function BlockActionBar({
  visible = false,
  onAddClick,
  onDragStart,
  className = "",
}: BlockActionBarProps) {
  return (
    <div
      className={`
        absolute -left-14 top-1/2 -translate-y-1/2
        flex items-center gap-0.5
        transition-opacity duration-150
        ${visible ? "opacity-100" : "opacity-0"}
        ${className}
      `}
    >
      {/* Add block button */}
      <IconButton
        icon={<Plus className="w-4 h-4" />}
        label="블록 추가"
        variant="ghost"
        size="sm"
        onClick={onAddClick}
      />

      {/* Drag handle */}
      <DragHandle
        visible
        onMouseDown={onDragStart}
        aria-label="블록 이동"
      />
    </div>
  );
}

export { type BlockActionBarProps };
